import React, { useEffect, useState } from 'react'
import PageContainer from 'src/components/container/PageContainer'
import DashboardCard from 'src/components/shared/DashboardCard'
import { Box, Grid } from '@mui/material'
import Users from './Users'
import { useMain } from '../hooks/useMain'
import ShowLoader from 'src/components/CustomComponents/ShowLoader'
import DashboardCard2 from 'src/components/shared/DashboardCard2'

const AllUsers = () => {
    const [users, setUsers] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    const { getAllOwners } = useMain();

    const getUsers = async () => {
        setShowLoader(true);
        const res = await getAllOwners();
        setUsers(res?.data);
        setShowLoader(false);
    }

    useEffect(() => {
        getUsers();

        return () => { }
    }, []);

    return (
        <PageContainer title="All Owners" description="this contains all users">
            <DashboardCard2 title="All Owners">
                <Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12}>
                            <Users data={users} setData={setUsers} />
                        </Grid>
                    </Grid>
                </Box>
                {showLoader && <ShowLoader value={showLoader} />}
            </DashboardCard2>
        </PageContainer>
    )
}

export default AllUsers
